import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { CUSTOMER_TYPE, CustomerType, FORM_ID, NUMBER_TYPE } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { get as Ajax_get } from "../../../app/Ajax";
import { CHECKOUT_SET_SELECTED_PHONE_NUMBER } from "../../../checkout/state/actionTypes";
import {
    isServiceSubscription as isServiceSubscriptionSelector,
    isSubscriptionBroadband,
} from "../../../checkout/state/selectors/subscriptionsSelectors";
import { actionTypes as RF_AT } from "../../../rapidform";
import { API_URL_AVAILABLE_NUMBERS } from "../../api";
import TEXT from "../../text-consts";
import { fulfilled } from "../../utils";
import {
    RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS,
    RETAILER_RESET_CURRENT_PHONE_NUMBER_CHECK_MESSAGES,
} from "../actionTypes";
import { getAvailablePhoneNumbers } from "../selectors/phoneNumbersSelectors";

export const resetAvailablePhoneNumbers = (): AnyAction => ({
    type: fulfilled(RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS),
    payload: [],
});

export const resetCurrentPhoneNumberCheckMessages =
    (id?: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: RETAILER_RESET_CURRENT_PHONE_NUMBER_CHECK_MESSAGES,
            id,
        });
    };

export const setSelectedPhoneNumber =
    (
        selectedPhoneNumber: string,
        customerType?: CustomerType,
        id?: string,
        editMode = false,
    ): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        const currentSubscriptionMemberId = id;
        dispatch({
            type: RF_AT.FORM_VALUE_CHANGED(FORM_ID.CUSTOMER_PRODUCT_USER),
            payload: {
                errorMessage: undefined,
                form: FORM_ID.CUSTOMER_PRODUCT_USER,
                inputName: `user-number`,
                inputValue: selectedPhoneNumber,
                visible: false,
            },
        });

        dispatch({
            type: RF_AT.FORM_VALUE_CHANGED(FORM_ID.CUSTOMER_PRODUCT_USER),
            payload: {
                errorMessage: undefined,
                form: FORM_ID.CUSTOMER_PRODUCT_USER,
                inputName: `user-type`,
                inputValue: customerType,
                visible: false,
            },
        });

        dispatch({
            type: CHECKOUT_SET_SELECTED_PHONE_NUMBER,
            subscriptionId: currentSubscriptionMemberId,
            allowedToProceed: editMode,
            customerType,
            selectedPhoneNumber,
        });
    };

const getNumberType = (state: RootState, subscriptionId: string) => {
    if (isServiceSubscriptionSelector(state, subscriptionId)) {
        return NUMBER_TYPE.TWELVE_DIGITS_VAS;
    }

    if (isSubscriptionBroadband(state, subscriptionId)) {
        return NUMBER_TYPE.TWELVE_DIGITS;
    }

    return NUMBER_TYPE.EIGHT_DIGITS;
};

export const fetchAvailableNumbers =
    (
        setFirstAsSubscriptionNumber = false,
        subscriptionId = "",
    ): ThunkAction<Promise<string[]>, RootState, unknown, AnyAction> =>
    async (dispatch, getState) => {
        const state = getState();

        const availablePhoneNumbers = getAvailablePhoneNumbers(state);
        if (availablePhoneNumbers.length > 0) {
            if (setFirstAsSubscriptionNumber) {
                dispatch(setSelectedPhoneNumber(availablePhoneNumbers[0], CUSTOMER_TYPE.NEW, subscriptionId));
            }
            return Promise.resolve(availablePhoneNumbers);
        }

        const numberType = getNumberType(state, subscriptionId);
        const response: Promise<string[]> = Ajax_get(
            { url: API_URL_AVAILABLE_NUMBERS(numberType, subscriptionId) },
            dispatch,
        );

        dispatch({
            type: RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS,
            payload: response,
            meta: {
                flashOnError: {
                    defaultErrorMessage: TEXT.ERRORS.FETCH_PHONE_NUMBER,
                },
            },
        });

        if (setFirstAsSubscriptionNumber) {
            return response.then((payload) => {
                dispatch(setSelectedPhoneNumber(payload[0], CUSTOMER_TYPE.NEW, subscriptionId));
                return payload;
            });
        }

        return response;
    };
